import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import { buildBreadcrumb } from "@/lib/seo";

export function Terms() { return <Legal title="Terms of Service" path="/terms" body={termsBody} desc="ADN Marketplace Terms of Service governing use of the platform by sellers and providers." />; }
export function Privacy() { return <Legal title="Privacy Policy" path="/privacy" body={privacyBody} desc="ADN Marketplace Privacy Policy explaining how we collect, use, and share information." />; }
export function Disclaimer() { return <Legal title="Disclaimer" path="/disclaimer" body={disclaimerBody} desc="Important disclaimers about ADN Marketplace. ADN is not a brokerage, lender, or law firm." />; }

function Legal({ title, body, path, desc }) {
  return (
    <div>
      <Seo
        title={title}
        description={desc}
        path={path}
        jsonLd={[
          buildBreadcrumb([
            { name: "Home", url: "https://adn-marketplace.com/" },
            { name: title, url: `https://adn-marketplace.com${path}` },
          ]),
        ]}
      />
      <Navbar />
      <section className="bg-[var(--adn-navy)] text-white grain">
        <div className="max-w-4xl mx-auto px-6 md:px-10 py-20">
          <h1 className="font-display text-5xl font-light">{title}</h1>
        </div>
      </section>
      <section className="max-w-4xl mx-auto px-6 md:px-10 py-16 prose prose-slate">
        {body}
      </section>
      <Footer />
    </div>
  );
}

const termsBody = (
  <div className="space-y-5 text-[15px] leading-relaxed text-[var(--adn-text-soft)]">
    <p>By using ADN Distressed Property Marketplace™ ("ADN") you agree to these Terms. ADN is a marketplace and technology platform that connects sellers with independent third-party providers.</p>
    <p>You agree to provide accurate information, to use the service lawfully, and to not misrepresent your identity, license status, or proof of funds. Providers must maintain valid credentials and comply with applicable laws.</p>
    <p>ADN may suspend or terminate accounts that violate these terms or platform policies. ADN does not guarantee a sale, a closing, an offer amount, or any specific outcome.</p>
  </div>
);
const privacyBody = (
  <div className="space-y-5 text-[15px] leading-relaxed text-[var(--adn-text-soft)]">
    <p>We collect the information you submit to operate the marketplace: property details, contact information, uploads, and account data. We share property and contact information with providers only as needed to deliver the service.</p>
    <p>We do not sell personal data. You may request deletion of your account at any time.</p>
  </div>
);
const disclaimerBody = (
  <div className="space-y-5 text-[15px] leading-relaxed text-[var(--adn-text-soft)]">
    <p>ADN does not provide legal, tax, financial, or real estate advice.</p>
    <p>ADN is a marketplace and technology platform.</p>
    <p>Offers are submitted by independent third-party providers. Sellers should consult licensed professionals before making decisions.</p>
    <p>No guarantee of sale, funding, foreclosure prevention, or final offer amount.</p>
  </div>
);
